import React from 'react';
import { ScheduleModals } from '../../../../components';
import { NoUpcomingSessions } from './no-upcoming-sessions.component';
import { NextSessions, NextSessionsProps } from './next-sessions';
import { AllSessions, AllSessionsProps } from './all-sessions';
import { useCurrentuser } from '@uplift/contexts';


type DashboardUpcomingProps = {
  nextSessions: NextSessionsProps['nextSessions'];
  allSessions: AllSessionsProps['sessions'];
  refetchAppointments: () => void;
  needToMatchTherapist?: boolean;
};


export const DashboardUpcoming: React.FC<DashboardUpcomingProps> = ({
  nextSessions,
  allSessions,
  refetchAppointments,
  needToMatchTherapist,
}) => {
  const user = useCurrentuser();

  if (nextSessions?.length) {
    return (
      <>
        <NextSessions nextSessions={nextSessions} />
        <AllSessions sessions={allSessions} nextSessions={nextSessions} />
        <ScheduleModals refetchAppointments={refetchAppointments} patientId={user.id} />
      </>
    );
  }

  return (
    <NoUpcomingSessions
      needToMatchTherapist={needToMatchTherapist}
    />
  );
};
